export const SET_USERINFO = 'SET_USERINFO';
export const SET_USER_PERMS = 'SET_USER_PERMS';

export const SET_DICT_ITEM = 'SET_DICT_ITEM';






// WEBPACK FOOTER //
// ./src/store/mutation-types.js